/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetOwnership
 */
export interface AssetOwnership {
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    primaryOwner?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    primaryOwnerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    primaryOwnerType?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    technicalOwner?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    technicalOwnerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    technicalOwnerType?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    businessOwner?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    businessOwnerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    businessOwnerType?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    securityOwner?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    securityOwnerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    securityOwnerType?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    ownershipSource?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    ownershipSourceSystem?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssetOwnership
     */
    ownershipLastUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    ownershipLastUpdatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetOwnership
     */
    delegatedTo?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssetOwnership
     */
    delegatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetOwnership
     */
    delegationExpiresAt?: Date;
}

/**
 * Check if a given object implements the AssetOwnership interface.
 */
export function instanceOfAssetOwnership(value: object): value is AssetOwnership {
    return true;
}

export function AssetOwnershipFromJSON(json: any): AssetOwnership {
    return AssetOwnershipFromJSONTyped(json, false);
}

export function AssetOwnershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetOwnership {
    if (json == null) {
        return json;
    }
    return {
        
        'primaryOwner': json['primaryOwner'] == null ? undefined : json['primaryOwner'],
        'primaryOwnerEmail': json['primaryOwnerEmail'] == null ? undefined : json['primaryOwnerEmail'],
        'primaryOwnerType': json['primaryOwnerType'] == null ? undefined : json['primaryOwnerType'],
        'technicalOwner': json['technicalOwner'] == null ? undefined : json['technicalOwner'],
        'technicalOwnerEmail': json['technicalOwnerEmail'] == null ? undefined : json['technicalOwnerEmail'],
        'technicalOwnerType': json['technicalOwnerType'] == null ? undefined : json['technicalOwnerType'],
        'businessOwner': json['businessOwner'] == null ? undefined : json['businessOwner'],
        'businessOwnerEmail': json['businessOwnerEmail'] == null ? undefined : json['businessOwnerEmail'],
        'businessOwnerType': json['businessOwnerType'] == null ? undefined : json['businessOwnerType'],
        'securityOwner': json['securityOwner'] == null ? undefined : json['securityOwner'],
        'securityOwnerEmail': json['securityOwnerEmail'] == null ? undefined : json['securityOwnerEmail'],
        'securityOwnerType': json['securityOwnerType'] == null ? undefined : json['securityOwnerType'],
        'ownershipSource': json['ownershipSource'] == null ? undefined : json['ownershipSource'],
        'ownershipSourceSystem': json['ownershipSourceSystem'] == null ? undefined : json['ownershipSourceSystem'],
        'ownershipLastUpdated': json['ownershipLastUpdated'] == null ? undefined : (new Date(json['ownershipLastUpdated'])),
        'ownershipLastUpdatedBy': json['ownershipLastUpdatedBy'] == null ? undefined : json['ownershipLastUpdatedBy'],
        'delegatedTo': json['delegatedTo'] == null ? undefined : json['delegatedTo'],
        'delegatedAt': json['delegatedAt'] == null ? undefined : (new Date(json['delegatedAt'])),
        'delegationExpiresAt': json['delegationExpiresAt'] == null ? undefined : (new Date(json['delegationExpiresAt'])),
    };
}

export function AssetOwnershipToJSON(json: any): AssetOwnership {
    return AssetOwnershipToJSONTyped(json, false);
}

export function AssetOwnershipToJSONTyped(value?: AssetOwnership | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primaryOwner': value['primaryOwner'],
        'primaryOwnerEmail': value['primaryOwnerEmail'],
        'primaryOwnerType': value['primaryOwnerType'],
        'technicalOwner': value['technicalOwner'],
        'technicalOwnerEmail': value['technicalOwnerEmail'],
        'technicalOwnerType': value['technicalOwnerType'],
        'businessOwner': value['businessOwner'],
        'businessOwnerEmail': value['businessOwnerEmail'],
        'businessOwnerType': value['businessOwnerType'],
        'securityOwner': value['securityOwner'],
        'securityOwnerEmail': value['securityOwnerEmail'],
        'securityOwnerType': value['securityOwnerType'],
        'ownershipSource': value['ownershipSource'],
        'ownershipSourceSystem': value['ownershipSourceSystem'],
        'ownershipLastUpdated': value['ownershipLastUpdated'] == null ? undefined : ((value['ownershipLastUpdated']).toISOString()),
        'ownershipLastUpdatedBy': value['ownershipLastUpdatedBy'],
        'delegatedTo': value['delegatedTo'],
        'delegatedAt': value['delegatedAt'] == null ? undefined : ((value['delegatedAt']).toISOString()),
        'delegationExpiresAt': value['delegationExpiresAt'] == null ? undefined : ((value['delegationExpiresAt']).toISOString()),
    };
}

